import { render, staticRenderFns } from "./PaymentBreakdownChart.vue?vue&type=template&id=b70087c6&scoped=true"
import script from "./PaymentBreakdownChart.vue?vue&type=script&lang=js"
export * from "./PaymentBreakdownChart.vue?vue&type=script&lang=js"
import style0 from "./PaymentBreakdownChart.vue?vue&type=style&index=0&id=b70087c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70087c6",
  null
  
)

export default component.exports